import Box from '@mui/material/Box';
import React from 'react';

/**
 * Full-page frame for the System Screens, splash and Sign In. ARC's #root is
 * a full-height flex row with body scrolling turned off (public/index.html),
 * so a full page has to fill it and scroll inside itself.
 */
export function GateFrame(props: { children: React.ReactNode }) {
  return (
    <Box sx={{ flex: 1, minWidth: 0, height: '100%', overflowY: 'auto' }}>
      {props.children}
    </Box>
  );
}
